/** Aligné sur scripts/plan-comparison-data.cjs (#802, #926, #1360). */
export const PLAN_COMPARISON_ROW_IDS = [
  'payments',
  'bookings',
  'clients',
  'services',
  'messaging',
  'email_reminders',
  'sms_reminders',
  'invoicing',
  'packages',
  'notes',
  'events',
  'stats',
  'profile',
  'support',
] as const;

export type PlanComparisonRowId = (typeof PLAN_COMPARISON_ROW_IDS)[number];

/** `no` = cellule Essentiel atténuée (fonction absente du gratuit). */
export const PLAN_COMPARISON_ESSENTIAL_KIND: Record<PlanComparisonRowId, 'yes' | 'no'> = {
  payments: 'no',
  bookings: 'yes',
  clients: 'yes',
  services: 'yes',
  messaging: 'no',
  email_reminders: 'yes',
  sms_reminders: 'no',
  invoicing: 'no',
  packages: 'no',
  notes: 'no',
  events: 'no',
  stats: 'no',
  profile: 'yes',
  support: 'yes',
};

export const PLAN_COMPARISON_ROWS = PLAN_COMPARISON_ROW_IDS;

export const SOCIAL_PROOF_LINKS = [
  { href: 'https://fr.trustpilot.com/review/rintintin-pro.com', label: 'Avis Trustpilot' },
  { href: 'https://www.capterra.fr/software/1079257/rintintin-pro', label: 'Fiche Capterra' },
  { href: 'https://apps.apple.com/fr/app/rintintin-pro/id6754002576', label: 'App Store iOS' },
  { href: 'https://play.google.com/store/apps/details?id=io.rintintin.app', label: 'Google Play' },
] as const;
